var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app-container"},[_c('base-sidebar',{attrs:{"sidebarItems":_vm.sidebarItems}}),_c('div',{staticClass:"app-wrapper pa-4"},[_c('base-header'),_vm._t("default")],2),_c('base-notification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }